<template>
    <div class="page address">
        <!-- 头部 -->
        <head-bar title="收货地址" :fixed="true">
            <template v-slot:right>
                <div class="head-right-slot">
                    <span @click="handleEdit()">新增</span>
                </div>
            </template>
        </head-bar>
        <!-- 内容 -->
        <div class="content">
            <van-tabs v-model="activeIndex" @click="tabClick" color="#4BC227">
                <van-tab title="物流地址">
                    <div v-if="list1.length > 0" class="address-box">
                        <ul>
                            <li v-for="(item, index) in list1" :key="index">
                                <h4>
                                    {{
                                        item.province +
                                            item.city +
                                            item.district +
                                            item.detailAddress
                                    }}
                                    <van-tag
                                        type="primary"
                                        v-if="item.defaultFlag"
                                        >默认
                                    </van-tag>
                                </h4>
                                <p>
                                    <span>{{ item.receiver }}</span>
                                    <span>{{ item.receiverPhone }}</span>
                                </p>
                                <i
                                    class="linkman-edit-icon"
                                    @click="handleEdit(item.receiveAddressId)"
                                >
                                </i>
                            </li>
                        </ul>
                        <div class="address-button">
                            <van-button
                                type="primary"
                                @click="handleEdit()"
                                size="large"
                                round
                            >
                                + 新增物流地址
                            </van-button>
                        </div>
                    </div>
                    <empty-data
                        v-else
                        iconText="暂无收货地址"
                        :iconSrc="emptyIcon"
                        :paddingTop="7"
                        iconSize="slim"
                    />
                </van-tab>
                <van-tab title="送货上门地址">
                    <div v-if="list2.length > 0" class="address-box">
                        <ul>
                            <li v-for="(item, index) in list2" :key="index">
                                <h4>
                                    {{
                                        item.province +
                                            item.city +
                                            item.district +
                                            item.detailAddress
                                    }}
                                    <van-tag
                                        type="primary"
                                        v-if="
                                            item.defaultFlag && item.status == 1
                                        "
                                        >默认
                                    </van-tag>
                                    <van-tag
                                        color="#CCC"
                                        v-if="item.status != 1"
                                        >已失效</van-tag
                                    >
                                </h4>
                                <p>
                                    <span>{{ item.receiver }}</span>
                                    <span>{{ item.receiverPhone }}</span>
                                </p>
                                <i
                                    class="linkman-edit-icon"
                                    @click="handleEdit(item.receiveAddressId)"
                                >
                                </i>
                            </li>
                        </ul>
                        <div class="address-button">
                            <van-button
                                type="primary"
                                @click="handleEdit()"
                                size="large"
                                round
                            >
                                + 新增送货上门地址
                            </van-button>
                        </div>
                    </div>
                    <empty-data
                        v-else
                        iconText="暂无送货上门地址"
                        :iconSrc="emptyIcon"
                        :paddingTop="7"
                        iconSize="slim"
                    />
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
import HeadBar from "@/components/HeadBar";
import EmptyData from "@/components/EmptyData";
import axios from "axios";
import Vue from "vue";
import { Tab, Tabs, Tag, Button, Toast } from "vant";

Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Button).use(Toast);

export default {
    name: "Address",
    components: { HeadBar, EmptyData },
    data() {
        return {
            /* 路由参数 */
            query: {
                index: this.$route.query.index,
            },
            activeIndex: 0, // tab标签选中位置
            // 空数据icon
            emptyIcon: require("../../../public/images/user/address/address-location.png"),
            list1: [], // 物流地址列表数据
            list2: [], // 送货上门地址列表数据
        };
    },
    created() {
        // 有参数，则为tab标签下标赋值
        if (this.query.index) this.activeIndex = parseInt(this.query.index);
        this.getPageInfo();
    },
    methods: {
        /* 获取页面信息 */
        getPageInfo() {
            let _this = this;
            _this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            axios.all([this.findAddressList(0), this.findAddressList(1)]).then(
                axios.spread((res1, res2) => {
                    this.list1 = res1.data || [];
                    this.list2 = res2.data || [];
                    _this.$toast.clear();
                })
            );
        },
        /**
         * @description 查询 收货地址 或 上门送货地址
         * @param {number} type 类型: 0, 1
         */
        findAddressList(type) {
            const url = this.$api.userApi.queryAddressListApi;
            const params = {
                operation: "select",
                context: {
                    distributionType: type,
                },
            };
            return this.$axios.post(url, params);
        },
        /* 新增/编辑 */
        handleEdit(id) {
            // 获取跳转页面
            const pathArr = [
                "/user/address/logistics",
                "/user/address/doorstep",
            ];
            const path = pathArr[this.activeIndex];

            this.$router.push({
                path: path,
                query: { id },
            });
        },
        /* tab点击事件 */
        tabClick(index) {
            this.$router.replace({
                path: "/user/address",
                query: {
                    index,
                },
            });
        },
    },
};
</script>

<style lang="less" scoped>
.address {
    .head-right-slot {
        text-align: right;
        padding-right: 20px;
        font-size: 32px;
    }

    .address-box {
        ul {
            background: #fff;

            li {
                font-size: 28px;
                margin: 0 30px;
                padding: 30px 0;
                border-top: 1px solid #f2f2f2;
                position: relative;

                &:first-child {
                    border-top: none;
                }

                h4 {
                    font-weight: normal;
                    text-align: justify;

                    .van-tag--primary {
                        background-color: #54b0fd;
                        margin-left: 5px;
                    }
                }

                p {
                    color: #999;
                    margin-top: 10px;

                    span {
                        margin-right: 20px;
                    }
                }

                .linkman-edit-icon {
                    position: absolute;
                    bottom: 4px;
                    right: 0;
                    transform: translateY(-50%);
                    width: 48px;
                    height: 48px;
                    background: url(../../../public/images/user/address/linkman-edit-icon.png)
                        center no-repeat;
                    background-size: 100%;
                }
            }
        }

        .address-button {
            padding: 60px 30px 80px;
        }
    }

    /deep/ [class*="van-hairline"]::after {
        border-top: 0;
    }

    /deep/ .van-tabs__wrap {
        margin-bottom: 20px;
    }
}
</style>
